import { SmallCalculatorContainer } from "@component/assets/SmallCalculator/SmallCalculatorContainer";
import { submitLead } from "@component/assets/SmallCalculator/useLeadSubmit";
import { useEventTracking, withEventTrackingRef } from "@utils/useEventTracking";
import { useCallback, useState } from "react";
import { mapStepValuesToLeadRequest } from "./model/mapper";
import { LeadForm } from "./steps/LeadForm";
import type { StepIds, StepValues } from "./type";

interface Props {
	consultantId: string;
}

const PRODUCT_TYPE = "PERSONAL_MEETING";

export const PartnerOfficeLeadForm = withEventTrackingRef<Props, HTMLDivElement>(
	{
		componentName: "PartnerOfficeLeadForm",
		componentType: "leadform",
		productTypes: [PRODUCT_TYPE],
	},
	({ consultantId }: Props, ref) => {
		const [isSubmitted, setIsSubmitted] = useState(false);
		const { sendEvent } = useEventTracking();
		const onStep = useCallback(
			async (stepId: StepIds, stepValues: StepValues): Promise<StepIds> => {
				if (stepId === "lead-form") {
					try {
						const response = await submitLead(mapStepValuesToLeadRequest(stepValues, consultantId));
						const values = stepValues["lead-form"];

						sendEvent("BM_lead", {
							...values,
							leadId: response.leadId,
							position: 1,
							leadType: PRODUCT_TYPE,

							user_data: {
								email_address: values.email,
								phone_number: values.phone,
								address: {
									last_name: values.lastName,
									first_name: values.firstName,
									city: values.cityName,
								},
							},
						});

						setIsSubmitted(true);
					} catch (error) {
						console.error("Error submitting lead:", error);
					}
				}

				return "lead-form";
			},
			[sendEvent, consultantId],
		);

		return (
			<SmallCalculatorContainer
				ref={ref}
				classNames={{ card: "bg-gray shadow" }}
				initialStep="lead-form"
				onStep={onStep}
			>
				<LeadForm id="lead-form" isSubmitted={isSubmitted} disabled={isSubmitted} />
			</SmallCalculatorContainer>
		);
	},
);
